package com.parmartechnologies.core.navigation.model

import com.parmartechnologies.core.navigation.NavigationParam
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
data class NavParamStore(
    @SerialName("params") var params: List<NavParam>,
)

@Serializable
data class NavParam(
    @SerialName("route") var route: String,
    @SerialName("param") var param: NavigationParam,
)